const TITLE_STEP_DELAY_MS = 120;

const CATEGORY_TIMING = {
    activeDelayMs: 5000,
    activeSwitchMs: 1000,
    maxActiveItems: 5,
    titleExitMs: 1000,
    toFortuneMs: 1000,
};

const FORTUNE_TIMING = {
    introMs: 1000,
    spinMs: 2200,
    settlePauseMs: 1500,
    titleStepMs: 120,
    titleAnimMs: 420,
};

const AVA_TIMING = {
    startMs: 1200,
    switchMs: 1200,
    animMs: 800,
    titleExitMs: 1000,
    activeItems: 5,
};

const BASE_CSS_TIMING = {
    categoryTitleExitMs: 420,
    categoryTrackExitMs: 1000,
    categoryShowMs: 1000,
    categoryShowDelay1Ms: 1000,
    categoryShowDelay2Ms: 2000,
    categoryShowDelay3Ms: 3000,
    categoryShowDelay4Ms: 4000,
    categoryItemTransitionMs: 300,
    avaItemInMs: 600,
    avaItemInDelay1Ms: 400,
    avaItemInDelay2Ms: 600,
    avaTitleExitMs: 420,
    avaShiftMs: 500,
    avaCategoryExitMs: 500,
    avaCategoryEnterMs: 200,
    fortuneTitleWordMs: 420,
    fortuneTrackIntroMs: 600,
    fortuneIdleOpacityMs: 1500,
    fortuneSpinMs: 2200,
    fortuneSettleMs: 1000,
    fortunePrizeHighlightMs: 1500,
    fortunePrizeHighlightDelayMs: 1000,
};

const CATEGORY_TOTAL_MS = CATEGORY_TIMING.activeDelayMs + CATEGORY_TIMING.activeSwitchMs * CATEGORY_TIMING.maxActiveItems + CATEGORY_TIMING.titleExitMs + CATEGORY_TIMING.toFortuneMs;

const getFortuneCountExitMs = (wordCount, timing = FORTUNE_TIMING) => (wordCount - 1) * timing.titleStepMs + timing.titleAnimMs;

const getFortuneTotalMs = (countWordCount, timing = FORTUNE_TIMING) => {
    const countExitMs = getFortuneCountExitMs(countWordCount, timing);
    return timing.introMs + timing.spinMs + timing.settlePauseMs + countExitMs;
};

const AVA_TOTAL_MS = AVA_TIMING.startMs + AVA_TIMING.activeItems * (AVA_TIMING.switchMs + AVA_TIMING.animMs) + AVA_TIMING.titleExitMs;

const getScaledTimings = ({ queueDurationMs, isAi, fortuneWordCount }) => {
    const safeWordCount = Math.max(1, Number(fortuneWordCount) || 1);
    const baseFortuneTotalMs = getFortuneTotalMs(safeWordCount, FORTUNE_TIMING);
    const baseTotalMs = (isAi ? AVA_TOTAL_MS : CATEGORY_TOTAL_MS) + baseFortuneTotalMs;
    const scale = queueDurationMs && queueDurationMs > 0 ? queueDurationMs / baseTotalMs : 1;
    const scaleTiming = (timing, staticKeys = []) => Object.fromEntries(Object.entries(timing).map(([key, value]) => [key, typeof value === "number" && !staticKeys.includes(key) ? value * scale : value]));

    const category = scaleTiming(CATEGORY_TIMING, ["maxActiveItems"]);
    const fortune = scaleTiming(FORTUNE_TIMING);
    const ava = scaleTiming(AVA_TIMING, ["activeItems"]);
    const css = scaleTiming(BASE_CSS_TIMING);
    const fortuneCountExitMs = getFortuneCountExitMs(safeWordCount, fortune);
    const fortuneTotalMs = getFortuneTotalMs(safeWordCount, fortune);
    const categoryTotalMs = CATEGORY_TOTAL_MS * scale;
    const avaTotalMs = AVA_TOTAL_MS * scale;
    const totalMs = (isAi ? avaTotalMs : categoryTotalMs) + fortuneTotalMs;
    const titleStepDelayMs = TITLE_STEP_DELAY_MS * scale;

    return {
        scale,
        category,
        fortune,
        ava,
        fortuneCountExitMs,
        fortuneTotalMs,
        categoryTotalMs,
        avaTotalMs,
        totalMs,
        titleStepDelayMs,
        css,
    };
};

export { CATEGORY_TIMING, FORTUNE_TIMING, AVA_TIMING, BASE_CSS_TIMING, CATEGORY_TOTAL_MS, AVA_TOTAL_MS, TITLE_STEP_DELAY_MS, getFortuneCountExitMs, getFortuneTotalMs, getScaledTimings };
